module.exports = __webpack_public_path__ + "static/Slide02@1x.03dc8847.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Slide02@1x.png
// module id = 705
// module chunks = 216210090109534